import { render, staticRenderFns } from "./dark.vue?vue&type=template&id=6d921d6b"
import script from "./dark.vue?vue&type=script&lang=js"
export * from "./dark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports